import {
  registerOntologyMapping,
  type OntologyTypeMapping,
} from '../../../core/data-profiles/OntologyPropertyMap';

/**
 * Declarative entity projection only. Reporting, occupancy, succession, and
 * computed counts remain relationship/read-model facts and are never mirrored
 * into scalar shape properties here.
 */
const mappings: readonly OntologyTypeMapping[] = [
  {
    ontologyType: 'position',
    runtimeType: 'org_position',
    unknownPropertyStrategy: 'attrs',
    properties: [
      { ontologyKey: 'positionId', runtimePath: 'attrs.positionId', panelField: 'positionId', type: 'string' },
      { ontologyKey: 'name', runtimePath: 'attrs.name', panelField: 'name', type: 'string' },
      { ontologyKey: 'title', runtimePath: 'attrs.title', panelField: 'title', type: 'string' },
      { ontologyKey: 'department', runtimePath: 'attrs.department', panelField: 'department', type: 'string' },
    ],
  },
  {
    ontologyType: 'actor',
    runtimeType: 'org_person',
    unknownPropertyStrategy: 'attrs',
    properties: [
      { ontologyKey: 'personId', runtimePath: 'attrs.personId', panelField: 'personId', type: 'string' },
      { ontologyKey: 'name', runtimePath: 'attrs.name', panelField: 'name', type: 'string' },
      { ontologyKey: 'email', runtimePath: 'attrs.email', panelField: 'email', type: 'string' },
    ],
  },
  {
    ontologyType: 'department',
    runtimeType: 'org_department',
    unknownPropertyStrategy: 'attrs',
    properties: [
      { ontologyKey: 'departmentId', runtimePath: 'attrs.departmentId', panelField: 'departmentId', type: 'string' },
      { ontologyKey: 'name', runtimePath: 'attrs.name', panelField: 'name', type: 'string' },
    ],
  },
];

let registered = false;

export function registerOrgChartOntologyMappings(): void {
  if (registered) return;
  mappings.forEach(registerOntologyMapping);
  registered = true;
}
